
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface VolumeMultiplierFieldProps {
  form: UseFormReturn<any>;
  disabled?: boolean;
}

export const VolumeMultiplierField: React.FC<VolumeMultiplierFieldProps> = ({
  form,
  disabled = false
}) => {
  const { t } = useTranslation();
  const volumeMultiplierOptions = [0.2, 0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

  return (
    <FormField
      control={form.control}
      name="volume_multiplier"
      render={({ field }) => (
        <FormItem data-tour="prop-bot-volume-multiplier">
          <FormLabel>{t('volume_multiplier')}</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            value={field.value}
            disabled={disabled}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={t('select_volume_multiplier')} />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="max-h-60">
              {volumeMultiplierOptions.map(value => (
                <SelectItem key={value} value={value.toString()}>
                  {value}x
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
